import logo from 'assets/images/noshShop-long.png';

const Logo = () => <img src={logo} alt="Nosh Shop" width="100" height="35" style={{ objectFit: 'contain' }} />;

export default Logo;
